module.exports = __webpack_public_path__ + "img/icon-plus.933d592f.png";